import { FC } from "react"
import { useAppDispatch } from "store"
import { toggleIsUnder } from "store/slices/appSlice"
import {
  useGetBossEnergyQuery,
  useGetBossHealthQuery
} from "store/apis/bossAPI"
import { hapticFeedback } from "utils/hapticFeedback"
import { underPortalIcon, exclamationMarkIcon } from "assets/icons"
import styles from "./index.module.scss"

export const SideMenuUnder: FC = () => {
  const dispatch = useAppDispatch()
  const { data: bossHealth } = useGetBossHealthQuery()
  const { data: bossEnergy } = useGetBossEnergyQuery()

  const isBossAlive = (bossHealth?.health ?? 0) > 0
  const hasPveEnergy = (bossEnergy?.pve.current ?? 0) > 0
  const hasPvpEnergy = (bossEnergy?.pvp.current ?? 0) > 0
  const showBadge = isBossAlive && (hasPveEnergy || hasPvpEnergy)

  const handleClick = () => {
    hapticFeedback()
    dispatch(toggleIsUnder())
  }

  return (
    <div id="btn-under" className={styles.SideMenuUnder} onClick={handleClick}>
      <img src={underPortalIcon} alt="Portal" />
      {showBadge && (
        <div className={styles.SideMenuUnder_indicator}>
          <img src={exclamationMarkIcon} alt="" />
        </div>
      )}
    </div>
  )
}
